import { Box } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";

import { PatientEditPage } from "../../pages/PatientIndex/PatientEditPage.js";
import { routeFns } from "../../routePaths.js";
import { PopupDialog } from "~/components/design-system/index.js";

export const EditPatientDialog = ({
  refetchDraft,
}: {
  refetchDraft: () => void;
}) => {
  const navigate = useNavigate();
  const { formDraftId, patientId } = useParams();

  return (
    <>
      <PopupDialog
        open={true}
        onClose={() =>
          navigate(routeFns.formDraftsComplete(formDraftId!, patientId!))
        }
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            padding: "1em",
          }}
        >
          <PatientEditPage
            mode="editPatientDialog"
            refetchDraft={refetchDraft}
          />
        </Box>
      </PopupDialog>
    </>
  );
};
